// import request from "@/services/request";
import {mapGetters} from "vuex";
import axios from "axios";
import {saveBlobFile, saveFile} from "@/utils/saveFile";
import FilesController from "@/controllers/FilesController";

export const setFileFunctions = {
  data() {
    return {
      file: {
        name: 'Подтверждающие документы',
        types: ['application/pdf'],
      },
      downloadingFileForPrint: false,
      downloadingPrint: false,
      downloadingPrint2: false,
      downloadingPrintExcel: false,
      downloadingPrintExcel1: false,
      downloadingPrintExcel2: false,
      downloadingPrintExcel3: false,
      downloadingPrintExcel4: false,
      downloadingPrintExcel5: false,
      downloadingPrintExcel6: false,
      downloadingPrintExcel7: false,
      downloadingPrintExcel8: false,
      downloadingPrintExcel9: false,
      downloadingPrintExcel10: false,
      downloadingPrintExcel11: false,
      downloadingPrintExcel12: false,
      loadingFileToServer: {
        value: false,
        fileType: ''
      },
      downloadingFileToServer: {
        value: false,
        fileType: ''
      },
    }
  },
  computed: {
    ...mapGetters('keycloak', {getAuthData: 'getAuthData', getKeycloakData: 'getKeycloakData', userId: 'userId'}),
    token() {
      return this.getAuthData.token
    },
  },
  methods: {
    getFile() {
      throw new Error(
        ` add Function  getFile() {
      this.file = {...this.file, id: this.$attrs.value.fileId, fileType: 'ORG_APPEAL' };
    }, and if u wanna change fileFormat to data
     file: {
    name: 'Подтверждающие документы',
      types: ['application/pdf'],
       }`
      )
    },
    async uploadFile(event) {
      console.log(event);
      this.loadingFileToServer.value = true;
      this.loadingFileToServer.fileType = event.fileType;
      let fd = new FormData();
      fd.append('file', event.file);
      try {
        await FilesController.saveFile(event.fileType, event.file).then(data => {
          this.file = {...this.file, ...data};
        }).finally(() => this.loadingFileToServer.value = false)
      } catch (e) {
        this.loadingFileToServer.value = false;
        await this.addNotification({
          notificationStatus: 'error',
          notificationMessage: 'Ошибка загрузки',
          timeout: 3000
        })
      }
    },

    async downloadFile(event) {
      this.uploadNow = true;
      this.downloadingFileToServer.value = true;
      this.downloadingFileToServer.fileType = event.fileType;
      try {
        const response = await FilesController.getFile(event.id)
        this.downloadingFileToServer.value = false;
        this.downloadingFileToServer.fileType = event.fileType;
        saveFile({...response, fileBytes: response.file}, false);
      } catch (e) {
        this.downloadingFileToServer.value = false;
        this.downloadingFileToServer.fileType = event.fileType;
        console.log("e", e)
      }
    },

    async downloadFilePril(event) {
      this.uploadNow = true;
      this.downloadingFileToServer.value = true;
      this.downloadingFileToServer.fileType = event.fileType;
      try {
        const response = await FilesController.getPril(event.orgId, event.prilNum)
        this.downloadingFileToServer.value = false;
        this.downloadingFileToServer.fileType = event.fileType;
        saveFile({...response, fileBytes: response.file}, false);
      } catch (e) {
        this.downloadingFileToServer.value = false;
        this.downloadingFileToServer.fileType = event.fileType;
        console.log("e", e)
      }
    },

    async deleteFile(event) {
      try {
        const response = await FilesController.deleteFile(event.id)
        if (response) {
          this.file = {
            name: this.file.name,
            fileType: event.fileType,
            types: this.file.types
          }
        }
      } catch (e) {
        // this.uploadNow = false;
        await this.addNotification({
          notificationStatus: 'error',
          notificationMessage: 'Ошибка удаления',
          timeout: 3000
        });
        console.log("e delete", e)
      }
    },

    async replaceFile(event) {
      await this.deleteFile(event)
      await this.uploadFile(event)
    },

    async downloadPrint(alias, nameLoading = 'downloadingPrint', nameFile = '', extension = '') {
      this[nameLoading] = true;
      const args = [...arguments].filter((_, i) => i >= 4);
      const path = `/api/reports/getByAlias/${alias}${args.join('')}`;
      await this.downloadBlobDocument(path, extension, nameFile)
        .catch(e => console.error(e))
        .finally(() => this[nameLoading] = false);
    },

    async downloadEx(alias, nameLoading = 'downloadingPrint', nameFile = '', extension = '') {
      this[nameLoading] = true;
      const path = `/api/reports/${alias}`;
      await this.downloadBlobDocument(path, extension, nameFile)
        .catch(e => console.error(e))
        .finally(() => this[nameLoading] = false);
    },

    async downloadBlockPrint(id) {
      const path = `/api/reports/getOrgReport?orgId=${id}`;
      await this.downloadBlobDocument(path, "application/pdf", 'Печать.pdf')
        .catch(e => console.error(e))
    },

    async getSourceTable(regionId, nameFile = '', extension = '') {
      const path = `/api/stageData/import/get_source_culture?founderId=8&regionId=${regionId}`; // founderId=8 это временный хардкод минкульта
      await this.downloadBlobDocument(path, extension, nameFile)
        .catch(e => console.error(e))
    },

    async getSourceTable2(founderId, nameFile = '', extension = '') {
      const path = `/api/stageData/import/get_source?founderId=${founderId}`;
      await this.downloadBlobDocument(path, extension, nameFile)
        .catch(e => console.error(e))
    },

    async getSourceTableRegion(founderId, regionId, nameFile = '', extension = '') {
      const path = `/api/stageData/import/get_source_culture?founderId=${founderId}&regionId=${regionId}`; // founderId=8 это временный хардкод минкульта
      await this.downloadBlobDocument(path, extension, nameFile)
          .catch(e => console.error(e))
    },

    async getPrilPrikArchive(prikDate, prikNum) {
      this.downloadingPrintExcel11 = true;
      const path = `/api/reports/getPrilArchive?prikNum=${prikNum}&prikDate=${prikDate}`;
      await this.downloadBlobDocument(path, "application/zip", "Приложения к приказу (основные).zip")
        .catch(e => console.error(e)).finally(() => this.downloadingPrintExcel11 = false);
    },

    async getPrilPrikArchiveNr(prikDate, prikNum) {
      this.downloadingPrintExcel12 = true;
      const path = `/api/reports/getNrPrilArchive?prikNum=${prikNum}&prikDate=${prikDate}`;
      await this.downloadBlobDocument(path, "application/zip", "Приложения к приказу (новые регионы).zip")
          .catch(e => console.error(e)).finally(() => this.downloadingPrintExcel12 = false);
    },

    async downloadBlobDocument(api = '', type = '"application/pdf"', nameFile) {
      this.downloadingFileForPrint = true;
      await axios.get(api, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer   ${this.getKeycloakData?.token}`
        },
      })
        .then(response => saveBlobFile(response.data, nameFile ?? "Выгрузка файлов", type))
        .catch(e => console.error(e))
        .finally(() => this.downloadingFileForPrint = false);
    },
  }
}